// extracted by mini-css-extract-plugin
export default {"news":"news--jVL4u","news-item":"news-item--u75v3","newsItem":"news-item--u75v3","blink":"blink--B1g0R"};